
export default {
  TOKEN_CHECK_TIMEOUT: 'TOKEN_CHECK_TIMEOUT',
  TOKEN_REQUEST: "TOKEN_REQUEST",
  TOKEN_RECEIVE: "TOKEN_RECEIVE",
  TOKEN_FAILURE: "TOKEN_FAILURE",
  TOKEN_INITIAL: "TOKEN_INITIAL",
  TOKEN_CHECK: 'TOKEN_CHECK',
}